import {debounce} from '../utils/decorators';

const moveTo = new MoveTo({
  tolerance: 80,
  duration: 1200,
  easing: 'easeOutQuart',
});
const openedSelector = 'is-opened';
const recalcDelay = 300;


const initAccordion = () => {
  const $accordions = document.querySelectorAll('[data-accordion]');

  const openItem = (el, bodySelector) => {
    el.classList.toggle(openedSelector);
    const $body = el.querySelector(bodySelector);

    if ($body) {
      $body.style.height = `${$body.scrollHeight}px`;
    }
  };

  const closeItems = (nodes, target) => {
    for (let i = 0; i < nodes.length; i++) {
      const $body = nodes[i].querySelector(target);

      nodes[i].classList.remove(openedSelector);

      if ($body) {
        $body.style.height = null;
      }
    }
  };

  const recalcHeight = debounce(() => {
    $accordions.forEach((item) => {
      const targetBodySelector = item.dataset.accordion;

      if (targetBodySelector) {
        const $activeChild = item.querySelector(`.${openedSelector}`);

        if (!$activeChild) {
          return;
        }

        const $activeChildBody = $activeChild.querySelector(targetBodySelector);

        if ($activeChildBody) {
          $activeChildBody.style.height = null;
          $activeChildBody.style.height = `${$activeChildBody.scrollHeight}px`;
        }
      }
    });
  }, recalcDelay);

  $accordions.forEach((item) => {
    const moveToAnimation = item.dataset.animation || false;
    const targetBodySelector = item.dataset.accordion;
    const $accordionChilds = item.children;
    const resizeObserver = new ResizeObserver(() => {
      recalcHeight();
    });

    for (let i = 0; i < $accordionChilds.length; i++) {
      const $item = $accordionChilds[i];
      const itemSelector = $item.dataset.accordionButton;
      const $itemOpenerElement = $item;

      if (itemSelector) {
        $itemOpenerElement = $item.querySelector(itemSelector) || $item;
      }

      if (i === 0) {
        openItem($item, targetBodySelector); // open first child
      }

      $itemOpenerElement.addEventListener('click', () => {
        closeItems($accordionChilds, targetBodySelector);

        if (moveToAnimation) {
          moveTo.move($item);
        }

        openItem($item, targetBodySelector);
      });
    }

    resizeObserver.observe(document.body);
  });
};

export {initAccordion};
